import {Injectable, Injector} from "@angular/core";
import {ConfigurationService, EntityModel} from "@fedeltapointofsale/data-client";
import {CategoryData} from "./category.data";
import {ServerAuth} from "../../config";

@Injectable()
export class CategoryEntityModel extends EntityModel<CategoryData> {
    public hasCategoryMovePrivilege: boolean;
    public hasCategoryUpdatePrivilege: boolean;
    private configService: ConfigurationService;


    constructor(injector: Injector) {
        super(injector, CategoryData);
        this.configService = injector.get(ConfigurationService, null);
        (async () => {
            this.hasCategoryMovePrivilege = await this.configService.getBoolean(ServerAuth.MOVE_CATEGORY);
            this.hasCategoryUpdatePrivilege = await this.configService.getBoolean(ServerAuth.UPDATE_CATEGORY);
        })();
    }
}
